import { webApiWithResponse } from "../../../../../core/http/httpThunks";
import { ClientPerson } from "../../types";

export const updateClientPersonApi = (userId: string, person: ClientPerson) =>
	webApiWithResponse<string>({
		method: "PUT",
		url: "listing/updcliprs",
		params: {
			userId
		},
		data: person
	});

export default updateClientPersonApi;
